import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconCoinsStacked = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M17.3337 6.66667C17.3337 8.13943 14.0504 9.33333 10.0003 9.33333C5.95024 9.33333 2.66699 8.13943 2.66699 6.66667M17.3337 6.66667C17.3337 5.19391 14.0504 4 10.0003 4C5.95024 4 2.66699 5.19391 2.66699 6.66667M17.3337 6.66667V12.6095C15.705 13.0986 14.667 13.8386 14.667 14.6667M2.66699 6.66667V22.6667C2.66699 24.1394 5.95024 25.3333 10.0003 25.3333C11.7732 25.3333 13.3991 25.1046 14.667 24.7238V14.6667M2.66699 12C2.66699 13.4728 5.95024 14.6667 10.0003 14.6667C11.7732 14.6667 13.3991 14.4379 14.667 14.0571M2.66699 17.3333C2.66699 18.8061 5.95024 20 10.0003 20C11.7732 20 13.3991 19.7712 14.667 19.3905M29.3337 14.6667C29.3337 16.1394 26.0504 17.3333 22.0003 17.3333C17.9502 17.3333 14.667 16.1394 14.667 14.6667M29.3337 14.6667C29.3337 13.1939 26.0504 12 22.0003 12C17.9502 12 14.667 13.1939 14.667 14.6667M29.3337 14.6667V25.3333C29.3337 26.8061 26.0504 28 22.0003 28C17.9502 28 14.667 26.8061 14.667 25.3333V14.6667M29.3337 20C29.3337 21.4728 26.0504 22.6667 22.0003 22.6667C17.9502 22.6667 14.667 21.4728 14.667 20"
      strokeWidth="1.872"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconCoinsStacked;
